export default "__VITE_ASSET__BxECz7MO__"